import { render, staticRenderFns } from "./ProductFeeConfigModal.vue?vue&type=template&id=75b2d4af"
import script from "./ProductFeeConfigModal.vue?vue&type=script&lang=js"
export * from "./ProductFeeConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports